function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $aa344be62785b256$exports = require("./ar-AE.main.js");
var $615986c3475e7c8c$exports = require("./bg-BG.main.js");
var $6c6207692f1ab248$exports = require("./cs-CZ.main.js");
var $fb37a9d024dd70f8$exports = require("./da-DK.main.js");
var $d7780bd4790f7ae9$exports = require("./de-DE.main.js");
var $9cdf03311f06c4ac$exports = require("./el-GR.main.js");
var $f93fc9e164ae811c$exports = require("./en-US.main.js");
var $7426c3264bf5ffea$exports = require("./es-ES.main.js");
var $1115cc0042de790c$exports = require("./et-EE.main.js");
var $4e80389dccb9283f$exports = require("./fi-FI.main.js");
var $78ad6f738c1f38d1$exports = require("./fr-FR.main.js");
var $50fa4716d827cd97$exports = require("./he-IL.main.js");
var $7297908fac4cf6c2$exports = require("./hr-HR.main.js");
var $f95c1b06e1d5ba32$exports = require("./hu-HU.main.js");
var $437a8dc519258a01$exports = require("./it-IT.main.js");
var $bd0aa2b50092a836$exports = require("./ja-JP.main.js");
var $bbd8176c2e044bc1$exports = require("./ko-KR.main.js");
var $1af703df56ff5180$exports = require("./lt-LT.main.js");
var $9705eb4511dea9f8$exports = require("./lv-LV.main.js");
var $8ef984876a7160bc$exports = require("./nb-NO.main.js");
var $b6e9809e1ecaa25e$exports = require("./nl-NL.main.js");
var $deb2fa609661fe31$exports = require("./pl-PL.main.js");
var $591c8c054c84fa56$exports = require("./pt-BR.main.js");
var $f1633bd6cbc228e8$exports = require("./pt-PT.main.js");
var $14e09da03f3d1c5b$exports = require("./ro-RO.main.js");
var $63247a3456bc40d1$exports = require("./ru-RU.main.js");
var $22150dd20c353dd4$exports = require("./sk-SK.main.js");
var $701eb9a0385c55fd$exports = require("./sl-SI.main.js");
var $54684a4891ca6dc5$exports = require("./sr-SP.main.js");
var $545887f88a5a52db$exports = require("./sv-SE.main.js");
var $492d49420dd96ff4$exports = require("./tr-TR.main.js");
var $dc85765e85e8f267$exports = require("./uk-UA.main.js");
var $2157d63cb80c7c63$exports = require("./zh-CN.main.js");
var $0335c3ddb5f70cbe$exports = require("./zh-TW.main.js");
var $IwcIq$reactariafocus = require("@react-aria/focus");
var $IwcIq$reactariautils = require("@react-aria/utils");
var $IwcIq$reactstatelyform = require("@react-stately/form");
var $IwcIq$react = require("react");
var $IwcIq$reactarialabel = require("@react-aria/label");
var $IwcIq$reactariainteractions = require("@react-aria/interactions");
var $IwcIq$reactariai18n = require("@react-aria/i18n");
var $IwcIq$reactariaform = require("@react-aria/form");
var $IwcIq$internationalizeddate = require("@internationalized/date");
var $IwcIq$internationalizednumber = require("@internationalized/number");
var $IwcIq$reactariaspinbutton = require("@react-aria/spinbutton");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useDatePicker", function () {
  return $e90ae7c26a69c6b1$export$42df105a73306d51;
});
$parcel$export(module.exports, "useDateSegment", function () {
  return $5c015c6316d1904d$export$1315d136e6f7581;
});
$parcel$export(module.exports, "useDateField", function () {
  return $4acc2f407c169e55$export$5591b0b878c1a989;
});
$parcel$export(module.exports, "useTimeField", function () {
  return $4acc2f407c169e55$export$4c842f6a241dc825;
});
$parcel$export(module.exports, "useDateRangePicker", function () {
  return $20f695b1b69e6b9e$export$12fd5f0e9f4bb192;
});
$parcel$export(module.exports, "useDisplayNames", function () {
  return $934ac650a0aceb4b$export$d42c60378c8168f8;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

var $c1905b78f6d2f5bf$exports = {};
$c1905b78f6d2f5bf$exports = {
  "ar-AE": $aa344be62785b256$exports,
  "bg-BG": $615986c3475e7c8c$exports,
  "cs-CZ": $6c6207692f1ab248$exports,
  "da-DK": $fb37a9d024dd70f8$exports,
  "de-DE": $d7780bd4790f7ae9$exports,
  "el-GR": $9cdf03311f06c4ac$exports,
  "en-US": $f93fc9e164ae811c$exports,
  "es-ES": $7426c3264bf5ffea$exports,
  "et-EE": $1115cc0042de790c$exports,
  "fi-FI": $4e80389dccb9283f$exports,
  "fr-FR": $78ad6f738c1f38d1$exports,
  "he-IL": $50fa4716d827cd97$exports,
  "hr-HR": $7297908fac4cf6c2$exports,
  "hu-HU": $f95c1b06e1d5ba32$exports,
  "it-IT": $437a8dc519258a01$exports,
  "ja-JP": $bd0aa2b50092a836$exports,
  "ko-KR": $bbd8176c2e044bc1$exports,
  "lt-LT": $1af703df56ff5180$exports,
  "lv-LV": $9705eb4511dea9f8$exports,
  "nb-NO": $8ef984876a7160bc$exports,
  "nl-NL": $b6e9809e1ecaa25e$exports,
  "pl-PL": $deb2fa609661fe31$exports,
  "pt-BR": $591c8c054c84fa56$exports,
  "pt-PT": $f1633bd6cbc228e8$exports,
  "ro-RO": $14e09da03f3d1c5b$exports,
  "ru-RU": $63247a3456bc40d1$exports,
  "sk-SK": $22150dd20c353dd4$exports,
  "sl-SI": $701eb9a0385c55fd$exports,
  "sr-SP": $54684a4891ca6dc5$exports,
  "sv-SE": $545887f88a5a52db$exports,
  "tr-TR": $492d49420dd96ff4$exports,
  "uk-UA": $dc85765e85e8f267$exports,
  "zh-CN": $2157d63cb80c7c63$exports,
  "zh-TW": $0335c3ddb5f70cbe$exports
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $715562ad3b4cced4$export$4a931266a3838b86(state, ref, disableArrowNavigation) {
  var _ref = (0, $IwcIq$reactariai18n.useLocale)(),
    direction = _ref.direction;
  var focusManager = (0, $IwcIq$react.useMemo)(function () {
    return (0, $IwcIq$reactariafocus.createFocusManager)(ref);
  }, [ref]);
  // Open the popover on alt + arrow down
  var onKeyDown = function onKeyDown(e) {
    if (!e.currentTarget.contains(e.target)) return;
    if (e.altKey && (e.key === "ArrowDown" || e.key === "ArrowUp") && "setOpen" in state) {
      e.preventDefault();
      e.stopPropagation();
      state.setOpen(true);
    }
    if (disableArrowNavigation) return;
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") focusManager.focusNext();else focusManager.focusPrevious();
        break;
      case "ArrowRight":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") focusManager.focusPrevious();else focusManager.focusNext();
        break;
    }
  };
  // Focus the first placeholder segment from the end on mouse down/touch up in the field.
  var focusLast = function focusLast() {
    var _window_event;
    // Try to find the segment prior to the element that was clicked on.
    var target = (_window_event = window.event) === null || _window_event === void 0 ? void 0 : _window_event.target;
    var walker = (0, $IwcIq$reactariafocus.getFocusableTreeWalker)(ref.current, {
      tabbable: true
    });
    if (target) {
      walker.currentNode = target;
      target = walker.previousNode();
    }
    // If no target found, find the last element from the end.
    if (!target) {
      var last;
      do {
        last = walker.lastChild();
        if (last) target = last;
      } while (last);
    }
    // Now go backwards until we find an element that is not a placeholder.
    while (target === null || target === void 0 ? void 0 : target.hasAttribute("data-placeholder")) {
      var prev = walker.previousNode();
      if (prev && prev.hasAttribute("data-placeholder")) target = prev;else break;
    }
    if (target) target.focus();
  };
  var _ref2 = (0, $IwcIq$reactariainteractions.usePress)({
      preventFocusOnPress: true,
      allowTextSelectionOnPress: true,
      onPressStart: function onPressStart(e) {
        if (e.pointerType === "mouse") focusLast();
      },
      onPress: function onPress(e) {
        if (e.pointerType !== "mouse") focusLast();
      }
    }),
    pressProps = _ref2.pressProps;
  return (0, $IwcIq$reactariautils.mergeProps)(pressProps, {
    onKeyDown: onKeyDown
  });
}
var $4acc2f407c169e55$export$653eddfc964b0f8a = new WeakMap();
var $4acc2f407c169e55$export$300019f83c56d282 = "__role_" + Date.now();
var $4acc2f407c169e55$export$7b3062cd49e80452 = "__focusManager_" + Date.now();
function $4acc2f407c169e55$export$5591b0b878c1a989(props, state, ref) {
  var _state_value;
  var _state$displayValidat = state.displayValidation,
    isInvalid = _state$displayValidat.isInvalid,
    validationErrors = _state$displayValidat.validationErrors,
    validationDetails = _state$displayValidat.validationDetails;
  var _ref3 = (0, $IwcIq$reactarialabel.useField)(_objectSpread(_objectSpread({}, props), {}, {
      labelElementType: "span",
      isInvalid: isInvalid,
      errorMessage: props.errorMessage || validationErrors
    })),
    labelProps = _ref3.labelProps,
    fieldProps = _ref3.fieldProps,
    descriptionProps = _ref3.descriptionProps,
    errorMessageProps = _ref3.errorMessageProps;
  var valueOnFocus = (0, $IwcIq$react.useRef)(null);
  var _ref4 = (0, $IwcIq$reactariainteractions.useFocusWithin)(_objectSpread(_objectSpread({}, props), {}, {
      onFocusWithin: function onFocusWithin(e) {
        var _props_onFocus;
        valueOnFocus.current = state.value;
        (_props_onFocus = props.onFocus) === null || _props_onFocus === void 0 ? void 0 : _props_onFocus.call(props, e);
      },
      onBlurWithin: function onBlurWithin(e) {
        var _props_onBlur;
        state.confirmPlaceholder();
        if (state.value !== valueOnFocus.current) state.commitValidation();
        (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
      },
      onFocusWithinChange: props.onFocusChange
    })),
    focusWithinProps = _ref4.focusWithinProps;
  var stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, ( /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports))), "@react-aria/datepicker");
  var message = state.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription";
  var field = state.maxGranularity === "hour" ? "time" : "date";
  var description = state.value ? stringFormatter.format(message, _defineProperty({}, field, state.formatValue({
    month: "long"
  }))) : "";
  var descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  // If within a date picker or date range picker, the date field will have role="presentation" and an aria-describedby
  // will be passed in that references the value (e.g. entire range). Otherwise, add the field's value description.
  var describedBy = props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation" ? fieldProps["aria-describedby"] : [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  var propsFocusManager = props[$4acc2f407c169e55$export$7b3062cd49e80452];
  var focusManager = (0, $IwcIq$react.useMemo)(function () {
    return propsFocusManager || (0, $IwcIq$reactariafocus.createFocusManager)(ref);
  }, [propsFocusManager, ref]);
  var groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref, props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation");
  // Pass labels and other information to segments.
  $4acc2f407c169e55$export$653eddfc964b0f8a.set(state, {
    ariaLabel: props["aria-label"],
    ariaLabelledBy: [labelProps.id, props["aria-labelledby"]].filter(Boolean).join(" ") || undefined,
    ariaDescribedBy: describedBy,
    focusManager: focusManager
  });
  var autoFocusRef = (0, $IwcIq$react.useRef)(props.autoFocus);
  // When used within a date picker or date range picker, the field gets role="presentation"
  // rather than role="group". Since the date picker/date range picker already has a role="group"
  // with a label and description, and the segments are already labeled by this as well, this
  // avoids very verbose duplicate announcements.
  var fieldDOMProps;
  if (props[$4acc2f407c169e55$export$300019f83c56d282] === "presentation") fieldDOMProps = {
    role: "presentation"
  };else fieldDOMProps = (0, $IwcIq$reactariautils.mergeProps)(fieldProps, {
    role: "group",
    "aria-disabled": props.isDisabled || undefined,
    "aria-describedby": describedBy
  });
  (0, $IwcIq$react.useEffect)(function () {
    if (autoFocusRef.current) focusManager.focusFirst();
    autoFocusRef.current = false;
  }, [focusManager]);
  (0, $IwcIq$reactariautils.useFormReset)(props.inputRef, state.value, state.setValue);
  (0, $IwcIq$reactariaform.useFormValidation)(_objectSpread(_objectSpread({}, props), {}, {
    focus: function focus() {
      focusManager.focusFirst();
    }
  }), state, props.inputRef);
  var inputProps = {
    type: "hidden",
    name: props.name,
    value: ((_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.toString()) || ""
  };
  if (props.validationBehavior === "native") {
    // Use a hidden <input type="text"> rather than <input type="hidden">
    // so that an empty value blocks HTML form submission when the field is required.
    inputProps.type = "text";
    inputProps.hidden = true;
    inputProps.required = props.isRequired;
    // Ignore react warning.
    inputProps.onChange = function () {};
  }
  var domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  return {
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      onClick: function onClick() {
        focusManager.focusFirst();
      }
    }),
    fieldProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, fieldDOMProps, groupProps, focusWithinProps, {
      onKeyDown: function onKeyDown(e) {
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp: function onKeyUp(e) {
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    isInvalid: isInvalid,
    validationErrors: validationErrors,
    validationDetails: validationDetails
  };
}
function $4acc2f407c169e55$export$4c842f6a241dc825(props, state, ref) {
  var _state_timeValue;
  var res = $4acc2f407c169e55$export$5591b0b878c1a989(props, state, ref);
  res.inputProps.value = ((_state_timeValue = state.timeValue) === null || _state_timeValue === void 0 ? void 0 : _state_timeValue.toString()) || "";
  return res;
}
function $e90ae7c26a69c6b1$export$42df105a73306d51(props, state, ref) {
  var _objectSpread2;
  var buttonId = (0, $IwcIq$reactariautils.useId)();
  var dialogId = (0, $IwcIq$reactariautils.useId)();
  var fieldId = (0, $IwcIq$reactariautils.useId)();
  var stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, ( /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports))), "@react-aria/datepicker");
  var _state$displayValidat2 = state.displayValidation,
    isInvalid = _state$displayValidat2.isInvalid,
    validationErrors = _state$displayValidat2.validationErrors,
    validationDetails = _state$displayValidat2.validationDetails;
  var _ref5 = (0, $IwcIq$reactarialabel.useField)(_objectSpread(_objectSpread({}, props), {}, {
      labelElementType: "span",
      isInvalid: isInvalid,
      errorMessage: props.errorMessage || validationErrors
    })),
    labelProps = _ref5.labelProps,
    fieldProps = _ref5.fieldProps,
    descriptionProps = _ref5.descriptionProps,
    errorMessageProps = _ref5.errorMessageProps;
  var groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref);
  var labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  var _ref6 = (0, $IwcIq$reactariai18n.useLocale)(),
    locale = _ref6.locale;
  var date = state.formatValue(locale, {
    month: "long"
  });
  var description = date ? stringFormatter.format("selectedDateDescription", {
    date: date
  }) : "";
  var descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  var ariaDescribedBy = [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  var domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  var focusManager = (0, $IwcIq$react.useMemo)(function () {
    return (0, $IwcIq$reactariafocus.createFocusManager)(ref);
  }, [ref]);
  var _ref7 = (0, $IwcIq$reactariainteractions.useFocusWithin)(_objectSpread(_objectSpread({}, props), {}, {
      isDisabled: state.isOpen,
      onBlurWithin: props.onBlur,
      onFocusWithin: props.onFocus,
      onFocusWithinChange: props.onFocusChange
    })),
    focusWithinProps = _ref7.focusWithinProps;
  return {
    groupProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-labelledby": labelledBy,
      "aria-describedby": ariaDescribedBy,
      onKeyDown: function onKeyDown(e) {
        if (state.isOpen) return;
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp: function onKeyUp(e) {
        if (state.isOpen) return;
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      onClick: function onClick() {
        focusManager.focusFirst();
      }
    }),
    fieldProps: _objectSpread(_objectSpread({}, fieldProps), {}, (_objectSpread2 = {
      id: fieldId
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, (0, $4acc2f407c169e55$export$300019f83c56d282), "presentation"), "aria-describedby", ariaDescribedBy), "value", state.value), "onChange", state.setValue), "placeholderValue", props.placeholderValue), "hideTimeZone", props.hideTimeZone), "hourCycle", props.hourCycle), "shouldForceLeadingZeros", props.shouldForceLeadingZeros), "granularity", props.granularity), "isDisabled", props.isDisabled), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "isReadOnly", props.isReadOnly), "isRequired", props.isRequired), "validationBehavior", props.validationBehavior), (0, $IwcIq$reactstatelyform.privateValidationStateProp), state), "autoFocus", props.autoFocus), "name", props.name))),
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    buttonProps: _objectSpread(_objectSpread({}, descProps), {}, {
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy),
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": state.isOpen,
      isDisabled: props.isDisabled || props.isReadOnly,
      onPress: function onPress() {
        return state.setOpen(true);
      }
    }),
    dialogProps: {
      id: dialogId,
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy)
    },
    calendarProps: {
      autoFocus: true,
      value: state.dateValue,
      onChange: state.setDateValue,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      defaultFocusedValue: state.dateValue ? undefined : props.placeholderValue,
      isInvalid: state.isInvalid,
      errorMessage: typeof props.errorMessage === "function" ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(" ")
    },
    isInvalid: isInvalid,
    validationErrors: validationErrors,
    validationDetails: validationDetails
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore

function $934ac650a0aceb4b$export$d42c60378c8168f8() {
  var _ref8 = (0, $IwcIq$reactariai18n.useLocale)(),
    locale = _ref8.locale;
  var dictionary = (0, $IwcIq$reactariai18n.useLocalizedStringDictionary)((0, ( /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports))), "@react-aria/datepicker");
  return (0, $IwcIq$react.useMemo)(function () {
    // Try to use Intl.DisplayNames if possible. It may be supported in browsers, but not support the dateTimeField
    // type as that was only added in v2. https://github.com/tc39/intl-displaynames-v2
    try {
      // @ts-ignore
      return new Intl.DisplayNames(locale, {
        type: "dateTimeField"
      });
    } catch (err) {
      return new $934ac650a0aceb4b$var$DisplayNamesPolyfill(locale, dictionary);
    }
  }, [locale, dictionary]);
}
var $934ac650a0aceb4b$var$DisplayNamesPolyfill = /*#__PURE__*/function () {
  function $934ac650a0aceb4b$var$DisplayNamesPolyfill(locale, dictionary) {
    _classCallCheck(this, $934ac650a0aceb4b$var$DisplayNamesPolyfill);
    this.locale = locale;
    this.dictionary = dictionary;
  }
  _createClass($934ac650a0aceb4b$var$DisplayNamesPolyfill, [{
    key: "of",
    value: function of(field) {
      return this.dictionary.getStringForLocale(field, this.locale);
    }
  }]);
  return $934ac650a0aceb4b$var$DisplayNamesPolyfill;
}();
function $5c015c6316d1904d$export$1315d136e6f7581(segment, state, ref) {
  var enteredKeys = (0, $IwcIq$react.useRef)("");
  var _ref9 = (0, $IwcIq$reactariai18n.useLocale)(),
    locale = _ref9.locale;
  var displayNames = (0, $934ac650a0aceb4b$export$d42c60378c8168f8)();
  var _get = (0, $4acc2f407c169e55$export$653eddfc964b0f8a).get(state),
    ariaLabel = _get.ariaLabel,
    ariaLabelledBy = _get.ariaLabelledBy,
    ariaDescribedBy = _get.ariaDescribedBy,
    focusManager = _get.focusManager;
  var textValue = segment.isPlaceholder ? "" : segment.text;
  var options = (0, $IwcIq$react.useMemo)(function () {
    return state.dateFormatter.resolvedOptions();
  }, [state.dateFormatter]);
  var monthDateFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    month: "long",
    timeZone: options.timeZone
  });
  var hourDateFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    hour: "numeric",
    hour12: options.hour12,
    timeZone: options.timeZone
  });
  if (segment.type === "month" && !segment.isPlaceholder) {
    var monthTextValue = monthDateFormatter.format(state.dateValue);
    textValue = monthTextValue !== textValue ? "".concat(textValue, " \u2013 ").concat(monthTextValue) : monthTextValue;
  } else if (segment.type === "hour" && !segment.isPlaceholder) textValue = hourDateFormatter.format(state.dateValue);
  var _ref10 = (0, $IwcIq$reactariaspinbutton.useSpinButton)({
      // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
      // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
      // https://github.com/dequelabs/axe-core/issues/3505
      value: segment.value,
      textValue: textValue,
      minValue: segment.minValue,
      maxValue: segment.maxValue,
      isDisabled: state.isDisabled,
      isReadOnly: state.isReadOnly || !segment.isEditable,
      isRequired: state.isRequired,
      onIncrement: function onIncrement() {
        enteredKeys.current = "";
        state.increment(segment.type);
      },
      onDecrement: function onDecrement() {
        enteredKeys.current = "";
        state.decrement(segment.type);
      },
      onIncrementPage: function onIncrementPage() {
        enteredKeys.current = "";
        state.incrementPage(segment.type);
      },
      onDecrementPage: function onDecrementPage() {
        enteredKeys.current = "";
        state.decrementPage(segment.type);
      },
      onIncrementToMax: function onIncrementToMax() {
        enteredKeys.current = "";
        state.setSegment(segment.type, segment.maxValue);
      },
      onDecrementToMin: function onDecrementToMin() {
        enteredKeys.current = "";
        state.setSegment(segment.type, segment.minValue);
      }
    }),
    spinButtonProps = _ref10.spinButtonProps;
  var parser = (0, $IwcIq$react.useMemo)(function () {
    return new (0, $IwcIq$internationalizednumber.NumberParser)(locale, {
      maximumFractionDigits: 0
    });
  }, [locale]);
  var backspace = function backspace() {
    if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly && !segment.isPlaceholder) {
      var newValue = segment.text.slice(0, -1);
      var parsed = parser.parse(newValue);
      if (newValue.length === 0 || parsed === 0) state.clearSegment(segment.type);else state.setSegment(segment.type, parsed);
      enteredKeys.current = newValue;
    } else if (segment.type === "dayPeriod") state.clearSegment(segment.type);
  };
  var onKeyDown = function onKeyDown(e) {
    // Firefox does not fire selectstart for Ctrl/Cmd + A
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1742153
    if (e.key === "a" && ((0, $IwcIq$reactariautils.isMac)() ? e.metaKey : e.ctrlKey)) e.preventDefault();
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    switch (e.key) {
      case "Backspace":
      case "Delete":
        // Safari on iOS does not fire beforeinput for the backspace key because the cursor is at the start.
        e.preventDefault();
        e.stopPropagation();
        backspace();
        break;
    }
  };
  // Safari dayPeriod option doesn't work...
  var _ref11 = (0, $IwcIq$reactariai18n.useFilter)({
      sensitivity: "base"
    }),
    startsWith = _ref11.startsWith;
  var amPmFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    hour: "numeric",
    hour12: true
  });
  var am = (0, $IwcIq$react.useMemo)(function () {
    var date = new Date();
    date.setHours(0);
    return amPmFormatter.formatToParts(date).find(function (part) {
      return part.type === "dayPeriod";
    }).value;
  }, [amPmFormatter]);
  var pm = (0, $IwcIq$react.useMemo)(function () {
    var date = new Date();
    date.setHours(12);
    return amPmFormatter.formatToParts(date).find(function (part) {
      return part.type === "dayPeriod";
    }).value;
  }, [amPmFormatter]);
  // Get a list of formatted era names so users can type the first character to choose one.
  var eraFormatter = (0, $IwcIq$reactariai18n.useDateFormatter)({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  });
  var eras = (0, $IwcIq$react.useMemo)(function () {
    if (segment.type !== "era") return [];
    var date = (0, $IwcIq$internationalizeddate.toCalendar)(new (0, $IwcIq$internationalizeddate.CalendarDate)(1, 1, 1), state.calendar);
    var eras = state.calendar.getEras().map(function (era) {
      var eraDate = date.set({
        year: 1,
        month: 1,
        day: 1,
        era: era
      }).toDate("UTC");
      var parts = eraFormatter.formatToParts(eraDate);
      var formatted = parts.find(function (p) {
        return p.type === "era";
      }).value;
      return {
        era: era,
        formatted: formatted
      };
    });
    // Remove the common prefix from formatted values. This is so that in calendars with eras like
    // ERA0 and ERA1 (e.g. Ethiopic), users can press "0" and "1" to select an era. In other cases,
    // the first letter is used.
    var prefixLength = $5c015c6316d1904d$var$commonPrefixLength(eras.map(function (era) {
      return era.formatted;
    }));
    if (prefixLength) {
      var _iterator = _createForOfIteratorHelper(eras),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var era = _step.value;
          era.formatted = era.formatted.slice(prefixLength);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return eras;
  }, [eraFormatter, state.calendar, segment.type]);
  var onInput = function onInput(key) {
    if (state.isDisabled || state.isReadOnly) return;
    var newValue = enteredKeys.current + key;
    switch (segment.type) {
      case "dayPeriod":
        if (startsWith(am, key)) state.setSegment("dayPeriod", 0);else if (startsWith(pm, key)) state.setSegment("dayPeriod", 12);else break;
        focusManager.focusNext();
        break;
      case "era":
        {
          var matched = eras.find(function (e) {
            return startsWith(e.formatted, key);
          });
          if (matched) {
            state.setSegment("era", matched.era);
            focusManager.focusNext();
          }
          break;
        }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year":
        {
          if (!parser.isValidPartialNumber(newValue)) return;
          var numberValue = parser.parse(newValue);
          var segmentValue = numberValue;
          var allowsZero = segment.minValue === 0;
          if (segment.type === "hour" && state.dateFormatter.resolvedOptions().hour12) {
            switch (state.dateFormatter.resolvedOptions().hourCycle) {
              case "h11":
                if (numberValue > 11) segmentValue = parser.parse(key);
                break;
              case "h12":
                allowsZero = false;
                if (numberValue > 12) segmentValue = parser.parse(key);
                break;
            }
            if (segment.value >= 12 && numberValue > 1) numberValue += 12;
          } else if (numberValue > segment.maxValue) segmentValue = parser.parse(key);
          if (isNaN(numberValue)) return;
          var shouldSetValue = segmentValue !== 0 || allowsZero;
          if (shouldSetValue) state.setSegment(segment.type, segmentValue);
          if (Number(numberValue + "0") > segment.maxValue || newValue.length >= String(segment.maxValue).length) {
            enteredKeys.current = "";
            if (shouldSetValue) focusManager.focusNext();
          } else enteredKeys.current = newValue;
          break;
        }
    }
  };
  var onFocus = function onFocus() {
    enteredKeys.current = "";
    (0, $IwcIq$reactariautils.scrollIntoViewport)(ref.current, {
      containingElement: (0, $IwcIq$reactariautils.getScrollParent)(ref.current)
    });
    // Collapse selection to start or Chrome won't fire input events.
    var selection = window.getSelection();
    selection.collapse(ref.current);
  };
  var compositionRef = (0, $IwcIq$react.useRef)("");
  // @ts-ignore - TODO: possibly old TS version? doesn't fail in my editor...
  (0, $IwcIq$reactariautils.useEvent)(ref, "beforeinput", function (e) {
    e.preventDefault();
    switch (e.inputType) {
      case "deleteContentBackward":
      case "deleteContentForward":
        if (parser.isValidPartialNumber(segment.text) && !state.isReadOnly) backspace();
        break;
      case "insertCompositionText":
        // insertCompositionText cannot be canceled.
        // Record the current state of the element so we can restore it in the `input` event below.
        compositionRef.current = ref.current.textContent;
        // Safari gets stuck in a composition state unless we also assign to the value here.
        // eslint-disable-next-line no-self-assign
        ref.current.textContent = ref.current.textContent;
        break;
      default:
        if (e.data != null) onInput(e.data);
        break;
    }
  });
  (0, $IwcIq$reactariautils.useEvent)(ref, "input", function (e) {
    var inputType = e.inputType,
      data = e.data;
    switch (inputType) {
      case "insertCompositionText":
        // Reset the DOM to how it was in the beforeinput event.
        ref.current.textContent = compositionRef.current;
        // Android sometimes fires key presses of letters as composition events. Need to handle am/pm keys here too.
        // Can also happen e.g. with Pinyin keyboard on iOS.
        if (startsWith(am, data) || startsWith(pm, data)) onInput(data);
        break;
    }
  });
  (0, $IwcIq$reactariautils.useLayoutEffect)(function () {
    var element = ref.current;
    return function () {
      // If the focused segment is removed, focus the previous one, or the next one if there was no previous one.
      if (document.activeElement === element) {
        var prev = focusManager.focusPrevious();
        if (!prev) focusManager.focusNext();
      }
    };
  }, [ref, focusManager]);
  // spinbuttons cannot be focused with VoiceOver on iOS.
  var touchPropOverrides = (0, $IwcIq$reactariautils.isIOS)() || segment.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {};
  // Only apply aria-describedby to the first segment, unless the field is invalid. This avoids it being
  // read every time the user navigates to a new segment.
  var firstSegment = (0, $IwcIq$react.useMemo)(function () {
    return state.segments.find(function (s) {
      return s.isEditable;
    });
  }, [state.segments]);
  if (segment !== firstSegment && !state.isInvalid) ariaDescribedBy = undefined;
  var id = (0, $IwcIq$reactariautils.useId)();
  var isEditable = !state.isDisabled && !state.isReadOnly && segment.isEditable;
  // Prepend the label passed from the field to each segment name.
  // This is needed because VoiceOver on iOS does not announce groups.
  var name = segment.type === "literal" ? "" : displayNames.of(segment.type);
  var labelProps = (0, $IwcIq$reactariautils.useLabels)({
    "aria-label": "".concat(name).concat(ariaLabel ? ", ".concat(ariaLabel) : "").concat(ariaLabelledBy ? ", " : ""),
    "aria-labelledby": ariaLabelledBy
  });
  // Literal segments should not be visible to screen readers. We don't really need any of the above,
  // but the rules of hooks mean hooks cannot be conditional so we have to put this condition here.
  if (segment.type === "literal") return {
    segmentProps: {
      "aria-hidden": true
    }
  };
  return {
    segmentProps: (0, $IwcIq$reactariautils.mergeProps)(spinButtonProps, labelProps, _objectSpread(_objectSpread({
      id: id
    }, touchPropOverrides), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      "aria-invalid": state.isInvalid ? "true" : undefined,
      "aria-describedby": ariaDescribedBy,
      "aria-readonly": state.isReadOnly || !segment.isEditable ? "true" : undefined,
      "data-placeholder": segment.isPlaceholder || undefined,
      contentEditable: isEditable,
      suppressContentEditableWarning: isEditable,
      spellCheck: isEditable ? "false" : undefined,
      autoCapitalize: isEditable ? "off" : undefined,
      autoCorrect: isEditable ? "off" : undefined
    }, parseInt((0, $parcel$interopDefault($IwcIq$react)).version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint", isEditable ? "next" : undefined), "inputMode", state.isDisabled || segment.type === "dayPeriod" || segment.type === "era" || !isEditable ? undefined : "numeric"), "tabIndex", state.isDisabled ? undefined : 0), "onKeyDown", onKeyDown), "onFocus", onFocus), "style", {
      caretColor: "transparent"
    }), "onPointerDown", function onPointerDown(e) {
      e.stopPropagation();
    }), "onMouseDown", function onMouseDown(e) {
      e.stopPropagation();
    })))
  };
}
function $5c015c6316d1904d$var$commonPrefixLength(strings) {
  // Sort the strings, and compare the characters in the first and last to find the common prefix.
  strings.sort();
  var first = strings[0];
  var last = strings[strings.length - 1];
  for (var i = 0; i < first.length; i++) {
    if (first[i] !== last[i]) return i;
  }
  return 0;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $20f695b1b69e6b9e$export$12fd5f0e9f4bb192(props, state, ref) {
  var _commonFieldProps;
  var _state_value, _state_value1;
  var stringFormatter = (0, $IwcIq$reactariai18n.useLocalizedStringFormatter)((0, ( /*@__PURE__*/$parcel$interopDefault($c1905b78f6d2f5bf$exports))), "@react-aria/datepicker");
  var _state$displayValidat3 = state.displayValidation,
    isInvalid = _state$displayValidat3.isInvalid,
    validationErrors = _state$displayValidat3.validationErrors,
    validationDetails = _state$displayValidat3.validationDetails;
  var _ref12 = (0, $IwcIq$reactarialabel.useField)(_objectSpread(_objectSpread({}, props), {}, {
      labelElementType: "span",
      isInvalid: isInvalid,
      errorMessage: props.errorMessage || validationErrors
    })),
    labelProps = _ref12.labelProps,
    fieldProps = _ref12.fieldProps,
    descriptionProps = _ref12.descriptionProps,
    errorMessageProps = _ref12.errorMessageProps;
  var labelledBy = fieldProps["aria-labelledby"] || fieldProps.id;
  var _ref13 = (0, $IwcIq$reactariai18n.useLocale)(),
    locale = _ref13.locale;
  var range = state.formatValue(locale, {
    month: "long"
  });
  var description = range ? stringFormatter.format("selectedRangeDescription", {
    startDate: range.start,
    endDate: range.end
  }) : "";
  var descProps = (0, $IwcIq$reactariautils.useDescription)(description);
  var startFieldProps = {
    "aria-label": stringFormatter.format("startDate"),
    "aria-labelledby": labelledBy
  };
  var endFieldProps = {
    "aria-label": stringFormatter.format("endDate"),
    "aria-labelledby": labelledBy
  };
  var buttonId = (0, $IwcIq$reactariautils.useId)();
  var dialogId = (0, $IwcIq$reactariautils.useId)();
  var groupProps = (0, $715562ad3b4cced4$export$4a931266a3838b86)(state, ref);
  var ariaDescribedBy = [descProps["aria-describedby"], fieldProps["aria-describedby"]].filter(Boolean).join(" ") || undefined;
  var focusManager = (0, $IwcIq$react.useMemo)(function () {
    return (0, $IwcIq$reactariafocus.createFocusManager)(ref, {
      // Exclude the button from the focus manager.
      accept: function accept(element) {
        return element.id !== buttonId;
      }
    });
  }, [ref, buttonId]);
  var commonFieldProps = (_commonFieldProps = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_commonFieldProps, (0, $4acc2f407c169e55$export$7b3062cd49e80452), focusManager), (0, $4acc2f407c169e55$export$300019f83c56d282), "presentation"), "aria-describedby", ariaDescribedBy), "placeholderValue", props.placeholderValue), "hideTimeZone", props.hideTimeZone), "hourCycle", props.hourCycle), "granularity", props.granularity), "shouldForceLeadingZeros", props.shouldForceLeadingZeros), "isDisabled", props.isDisabled), "isReadOnly", props.isReadOnly), _defineProperty(_defineProperty(_commonFieldProps, "isRequired", props.isRequired), "validationBehavior", props.validationBehavior));
  var domProps = (0, $IwcIq$reactariautils.filterDOMProps)(props);
  var _ref14 = (0, $IwcIq$reactariainteractions.useFocusWithin)(_objectSpread(_objectSpread({}, props), {}, {
      isDisabled: state.isOpen,
      onBlurWithin: props.onBlur,
      onFocusWithin: props.onFocus,
      onFocusWithinChange: props.onFocusChange
    })),
    focusWithinProps = _ref14.focusWithinProps;
  var startFieldValidation = (0, $IwcIq$react.useRef)((0, $IwcIq$reactstatelyform.DEFAULT_VALIDATION_RESULT));
  var endFieldValidation = (0, $IwcIq$react.useRef)((0, $IwcIq$reactstatelyform.DEFAULT_VALIDATION_RESULT));
  return {
    groupProps: (0, $IwcIq$reactariautils.mergeProps)(domProps, groupProps, fieldProps, descProps, focusWithinProps, {
      role: "group",
      "aria-disabled": props.isDisabled || null,
      "aria-describedby": ariaDescribedBy,
      onKeyDown: function onKeyDown(e) {
        if (state.isOpen) return;
        if (props.onKeyDown) props.onKeyDown(e);
      },
      onKeyUp: function onKeyUp(e) {
        if (state.isOpen) return;
        if (props.onKeyUp) props.onKeyUp(e);
      }
    }),
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      onClick: function onClick() {
        focusManager.focusFirst();
      }
    }),
    buttonProps: _objectSpread(_objectSpread({}, descProps), {}, {
      id: buttonId,
      "aria-haspopup": "dialog",
      "aria-label": stringFormatter.format("calendar"),
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy),
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": state.isOpen,
      isDisabled: props.isDisabled || props.isReadOnly,
      onPress: function onPress() {
        return state.setOpen(true);
      }
    }),
    dialogProps: {
      id: dialogId,
      "aria-labelledby": "".concat(buttonId, " ").concat(labelledBy)
    },
    startFieldProps: _objectSpread(_objectSpread(_objectSpread({}, startFieldProps), commonFieldProps), {}, _defineProperty({
      value: (_state_value = state.value) === null || _state_value === void 0 ? void 0 : _state_value.start,
      onChange: function onChange(start) {
        return state.setDateTime("start", start);
      },
      autoFocus: props.autoFocus,
      name: props.startName
    }, (0, $IwcIq$reactstatelyform.privateValidationStateProp), {
      realtimeValidation: state.realtimeValidation,
      displayValidation: state.displayValidation,
      updateValidation: function updateValidation(e) {
        startFieldValidation.current = e;
        state.updateValidation((0, $IwcIq$reactstatelyform.mergeValidation)(e, endFieldValidation.current));
      },
      resetValidation: state.resetValidation,
      commitValidation: state.commitValidation
    })),
    endFieldProps: _objectSpread(_objectSpread(_objectSpread({}, endFieldProps), commonFieldProps), {}, _defineProperty({
      value: (_state_value1 = state.value) === null || _state_value1 === void 0 ? void 0 : _state_value1.end,
      onChange: function onChange(end) {
        return state.setDateTime("end", end);
      },
      name: props.endName
    }, (0, $IwcIq$reactstatelyform.privateValidationStateProp), {
      realtimeValidation: state.realtimeValidation,
      displayValidation: state.displayValidation,
      updateValidation: function updateValidation(e) {
        endFieldValidation.current = e;
        state.updateValidation((0, $IwcIq$reactstatelyform.mergeValidation)(startFieldValidation.current, e));
      },
      resetValidation: state.resetValidation,
      commitValidation: state.commitValidation
    })),
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps,
    calendarProps: {
      autoFocus: true,
      value: state.dateRange,
      onChange: state.setDateRange,
      minValue: props.minValue,
      maxValue: props.maxValue,
      isDisabled: props.isDisabled,
      isReadOnly: props.isReadOnly,
      isDateUnavailable: props.isDateUnavailable,
      allowsNonContiguousRanges: props.allowsNonContiguousRanges,
      defaultFocusedValue: state.dateRange ? undefined : props.placeholderValue,
      isInvalid: state.isInvalid,
      errorMessage: typeof props.errorMessage === "function" ? props.errorMessage(state.displayValidation) : props.errorMessage || state.displayValidation.validationErrors.join(" ")
    },
    isInvalid: isInvalid,
    validationErrors: validationErrors,
    validationDetails: validationDetails
  };
}